import { render } from "./item.vue?vue&type=template&id=b45bf14a"
import script from "./item.vue?vue&type=script&lang=js"
export * from "./item.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\avue\\avue3.0\\avue\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+compiler-sfc@3.5.12_vue@3.5.27_typescript@5.9.3__webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"packages/element-plus/crud/grid/item.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b45bf14a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b45bf14a', __exports__)) {
    console.log('reload')
    api.reload('b45bf14a', __exports__)
  }
  
  module.hot.accept("./item.vue?vue&type=template&id=b45bf14a", () => {
    console.log('re-render')
    api.rerender('b45bf14a', render)
  })

}


export default __exports__